import { render } from "./EmployeeImmigration.vue?vue&type=template&id=2747b3a5&scoped=true"
import script from "./EmployeeImmigration.vue?vue&type=script&lang=js"
export * from "./EmployeeImmigration.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=2747b3a5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2747b3a5"]])

export default __exports__